import Vue from 'vue'

export default
{
  _clusters: [],
  add (item) {
    try {
      this._load()
      this._clusters.push(item)
      this._save()
    } catch (e) {
      console.log(e)
    }
  },
  clear () {
    this._clusters = []
  },
  _removeOrphans (item) {
    this.remove(item)
  },
  getItem (item) {
    if (!item) return null
    this._load()
    let _cluster
    this._clusters.forEach(function (cluster) {
      if (cluster.layer === item) {
        _cluster = cluster
      }
    })
    return _cluster
  },
  get items () {
    return this._clusters
  },
  _load () {
    let session = Vue.prototype.$session
    if (session !== null) {
      try {
        this._clusters = session.has('clusters') ? session.get('clusters') : []
      } catch (e) {
        session.remove('clusters')
      }
    }
  },
  remove (item) {
    this._load()
    let index = this._clusters.findIndex(x => x.layer === item)
    if (index !== -1) {
      this._clusters.splice(index, 1)
    }
    this._save()
  },
  save (item) {
    this._load()
    let index = this._clusters.findIndex(x => x.source === item.source)
    if (index !== -1) {
      this._clusters[index] = item
    } else {
      this._clusters.push(item)
    }
    this._save()
  },
  _save () {
    let session = Vue.prototype.$session
    if (session !== null) {
      session.set('clusters', this._clusters)
    }
  }
}
